import { Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';

interface PdfIndexSectionsProps {
  modules: Array<{ name: string; type: string }>;
}

export const PdfIndexSections = ({ modules }: PdfIndexSectionsProps) => (
  <View>
    <Text style={styles.sectionTitle}>Indice</Text>

    <View style={styles.block}>
      {['Introduzione', 'Riepilogo', 'Schede dettagliate (Moduli)', 'Note e contatti'].map(
        (item) => (
          <View key={item} style={styles.listItem}>
            <Text style={styles.bullet}>-</Text>
            <Text style={styles.text}>{item}</Text>
          </View>
        )
      )}
    </View>

    <Text style={styles.subtitle}>Elenco moduli</Text>
    {modules.length === 0 ? (
      <Text style={[styles.text, styles.mutedText]}>Nessun modulo disponibile.</Text>
    ) : (
      modules.map((module, index) => (
        <View key={`${module.name}-${index}`} style={styles.listItem}>
          <Text style={styles.bullet}>-</Text>
          <Text style={styles.text}>
            {module.name}
            {module.type ? ` (${module.type})` : ''}
          </Text>
        </View>
      ))
    )}
  </View>
);
